import React from "react";

import BarChart from "components/pages/dashboard/chart/BarChart";
import usePatientComplianceAnalyticChart from "components/pages/dashboard/patient_compliance_analytic/chart/usePatientComplianceAnalyticChart";

const PatientComplianceAnalyticChart = ({ data, filter, schedule }) => {
  const { options, chartData } = usePatientComplianceAnalyticChart(
    data,
    filter,
    schedule
  );

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer" }}
    />
  );
};

export default PatientComplianceAnalyticChart;
